import React from 'react';
import CircularExampleTile from '../circular-example-tile/circular-example-tile';
import FetchRuntimeTileData from '@components/runtime-components/fetch-runtime-tile-data';
import styled from '@emotion/styled/macro';
import Translate from '@utils/translation-functions';
import vars from '@variables';
import { CircularExamplesSidebarProps } from './circular-examples-sidebar.types';
import { generateKey } from '@utils/utils';
import { GTM_ID } from '../../../../../common/constants/gtmIds';
import { LetterboxLinkAtom } from '@atoms/link-atoms/link-atoms';

const CircularExamplesSidebar: React.FC<CircularExamplesSidebarProps> = ({
  tiles = [],
  className,
  sidebarCta = {},
  translate = true,
}) => {
  if (tiles && tiles.length > 0) {
    return (
      <div data-testid="circular-examples-sidebar" className={className}>
        {tiles.map((tile, index) => {
          if (tile.renderType === 'standard') {
            return (
              <CircularExampleTile
                className={className}
                data-testid="circular-example-tile"
                key={generateKey('std', index)}
                title={tile.title}
                gatsbyImageData={tile.gatsbyImageData}
                imageUrl={tile.imageUrl}
                imageAlt={tile.imageAlt}
                imageFormat={tile.imageFormat}
                url={tile.url}
              />
            );
          } else if (tile.renderType === 'runtime') {
            return (
              <FetchRuntimeTileData
                contentfulId={tile.contentfulId}
                contentType={tile.contentType}
                tileType="standard"
                key={generateKey('rtt', index)}
                ceTile={true}
                className={className}
                data-testid="circular-example-tile"
              />
            );
          } else {
            console.warn(`tile.renderType not matched: `, tile.renderType);
            return null;
          }
        })}
        {sidebarCta.url && (
          <LetterboxLinkAtom
            url={sidebarCta.url}
            dataTestId="circular-examples-sidebar-link"
            gtmId={GTM_ID.TILE_BLOCK_CTA}
          >
            {sidebarCta.text
              ? sidebarCta.text
              : Translate('view all examples', translate)}
          </LetterboxLinkAtom>
        )}
      </div>
    );
  }
  return null;
};

const StyledCircularExampleSidebar = styled(CircularExamplesSidebar)`
  display: flex;
  flex-direction: column;
  width: 26.6rem;

  ${CircularExampleTile} {
    margin-bottom: ${vars.spacingM};
  }
`;

export default StyledCircularExampleSidebar;
